import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useData } from '../contexts/DataContext';
import * as FiIcons from 'react-icons/fi';
import * as FaIcons from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';
import SectionHeader from './SectionHeader';

const { FiChevronDown, FiChevronUp } = FiIcons;
const { FaFish } = FaIcons;

const TankSelector = () => {
  const { data, setActiveTask } = useData();
  const [isOpen, setIsOpen] = useState(false);
  
  const activeTank = data.tanks.find(tank => tank.isActive) || data.tanks[0];
  
  const getTankSizeLabel = (size) => {
    if (size < 1000) return `${size}L`;
    return `${size/1000}kL`;
  };

  const handleSelect = (tankId) => {
    setActiveTask(tankId);
    setIsOpen(false);
  };

  return (
    <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-200 mb-4">
      <SectionHeader 
        title="Active Tank" 
        infoText="Select the tank you want to view or manage. All data shown will be filtered for this tank."
      />
      
      <div className="relative">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="w-full p-3 bg-gray-50 rounded-lg border border-gray-200 flex items-center justify-between hover:bg-gray-100 transition-colors"
        >
          <div className="flex items-center">
            <div className="w-10 h-10 bg-aqua-500 rounded-lg flex items-center justify-center mr-3">
              <SafeIcon icon={FaFish} className="w-5 h-5 text-white" />
            </div>
            <div className="text-left">
              <div className="font-medium text-gray-900">{activeTank.name}</div>
              <div className="text-sm text-gray-600">{getTankSizeLabel(activeTank.size)}</div>
            </div>
          </div>
          <SafeIcon icon={isOpen ? FiChevronUp : FiChevronDown} className="w-5 h-5 text-gray-500" />
        </button>
        
        <AnimatePresence>
          {isOpen && (
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.2 }}
              className="absolute z-30 mt-2 w-full bg-white rounded-lg border border-gray-200 shadow-lg overflow-hidden"
            >
              <div className="max-h-60 overflow-y-auto py-1">
                {data.tanks.map((tank) => (
                  <button
                    key={tank.id}
                    onClick={() => handleSelect(tank.id)}
                    className={`w-full px-3 py-2 flex items-center hover:bg-gray-50 transition-colors ${
                      tank.isActive ? 'bg-aqua-50' : ''
                    }`}
                  >
                    <div className={`w-8 h-8 rounded-lg flex items-center justify-center mr-3 ${
                      tank.isActive ? 'bg-aqua-500' : 'bg-gray-200'
                    }`}>
                      <SafeIcon 
                        icon={FaFish} 
                        className={`w-4 h-4 ${tank.isActive ? 'text-white' : 'text-gray-500'}`} 
                      />
                    </div>
                    <div className="text-left">
                      <div className={`font-medium ${tank.isActive ? 'text-aqua-700' : 'text-gray-900'}`}>
                        {tank.name}
                      </div>
                      <div className="text-xs text-gray-600">{getTankSizeLabel(tank.size)}</div>
                    </div>
                  </button>
                ))}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default TankSelector;